import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Node,
  Taxonomy as TaxonomyTerm,
  entityGetByPath,
  referenceLoadingReset,
  useMetatag,
} from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import Page from '../Page';
import Forbidden from '../Forbidden';
import NotFound from '../NotFound';
import ServerError from '../ServerError';
import { ContextualActionsWrapper } from '../../components';

const Entity = ({
  customPath,
  prevPath,
}) => {
  const dispatch = useDispatch();
  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const path = useSelector((state) => state.getIn(['router', 'location', 'pathname']));
  const entityStatus = useSelector((state) => state.getIn(['entity', 'status']));
  const entityExists = useSelector((state) => state.getIn(['entity', 'exists']));

  const { title } = useMetatag();

  const newPath = customPath || path;
  const entityNotLoaded = !entityType || !entityId;
  const pathIsDifferentAndHasEntity = (newPath !== prevPath) && entityStatus !== undefined;

  useEffect(() => {
    if (entityNotLoaded || (!entityNotLoaded && pathIsDifferentAndHasEntity && prevPath !== undefined)) {
      dispatch(referenceLoadingReset());
      dispatch(entityGetByPath(newPath));
    }
  }, [dispatch, entityNotLoaded, pathIsDifferentAndHasEntity, newPath, prevPath]);

  const renderPage = () => {
    if (entityStatus === 403) {
      return (
        <Container>
          <Forbidden />
        </Container>
      );
    } else if (entityStatus === 404) {
      return (
        <Container>
          <NotFound />
        </Container>
      );
    } else if (entityStatus === 500) {
      return (
        <Container>
          <ServerError />
        </Container>
      );
    }

    return (
      <ContextualActionsWrapper>
        <Page title={title?.attributes.content}>
          {entityType === 'node' && (
            <Node root id={entityId} />
          )}
          {entityType === 'taxonomy_term' && (
            <TaxonomyTerm root id={entityId} />
          )}
        </Page>
      </ContextualActionsWrapper>
    );
  };

  if ((!entityType || !entityId) && entityExists) {
    return null;
  }

  return (
    <div>
      {renderPage()}
    </div>
  );
};

export default Entity;
